module.exports = __webpack_public_path__ + "static/media/577121_575598889117645_801807966_n.5fd7e583.jpg";